import type { ShiftMeal } from '@libs/data-access/queries'

import type { MealValue } from '../components/MealRow/MealRow'

const getMeals = (
  mealDefault: boolean,
  defaultMealType?: string,
  shiftMeals?: ShiftMeal[],
  shiftId?: number
): { value: MealValue }[] => {
  if (shiftMeals && shiftMeals.length > 0) {
    return shiftMeals.map(shiftMeal => ({
      value: {
        id: shiftMeal.id || undefined,
        initialMeal: shiftMeal.planned_meal_type,
        checked: true,
        meal: {
          id: shiftMeal.id || undefined,
          value: shiftMeal.planned_meal_type
        }
      }
    }))
  }

  return mealDefault && !shiftId
    ? [
        {
          value: {
            id: undefined,
            initialMeal: undefined,
            checked: true,
            meal: {
              id: undefined,
              value: defaultMealType
            }
          }
        }
      ]
    : []
}

export default getMeals
